import * as React from 'react';

import FileDwg32 from './FileDwg32';

export const fileDwg32 = () => <FileDwg32 />;

export default {
    title: 'Icon|Content|FileDwg32',
    component: FileDwg32,
    parameters: {
        notes: "`import FileDwg32 from 'box-ui-elements/es/icon/content/FileDwg32';`",
    },
};
